  // circleProgress
  if ($('.draw-circle').length) {

    if ($('.draw-circle').length) {
        $('.draw-circle').circleProgress({
            emptyFill: "rgba(0, 0, 0, 0)",
            //   startAngle: 2.5
        });

    }
}
if($('#myChart').length>0){
var myChart = new Chart(
  document.getElementById('myChart'),
  config
);
}






function readURLInstructor(input) {
  if (input.files && input.files[0]) {
      var reader = new FileReader();

      reader.onload = function(e) {
          $('#imgInstructor').attr('src', e.target.result);
      }

      reader.readAsDataURL(input.files[0]); // convert to base64 string
  }
}

function readURLStudent(input) {
  if (input.files && input.files[0]) {
      var reader = new FileReader();

      reader.onload = function(e) {
          $('#imgStudent').attr('src', e.target.result);
      }

      reader.readAsDataURL(input.files[0]); // convert to base64 string
  }
}

$("#imgInpStudent").change(function() {
  readURLStudent(this);
});

$("#imgInpInstructor ").change(function() {
  readURLInstructor(this);
});



$(".custom-file-input").on("change", function() {
  var fileName = $(this).val().split("\\").pop();
  $(this).siblings(".custom-file-label").addClass("selected").html(fileName);
});

copyToClipboard=function(element) {
  var $temp = $("<input>");
  $("body").append($temp);
  $temp.val($(element).text()).select();
  document.execCommand("copy");
  $temp.remove();
  $(element).closest('.text-to-copy').tooltip('show');
  setTimeout(function() {
      $(element).closest('.text-to-copy').tooltip('hide');

  }, 1000)

}